(function () {
  // このスクリプト自体が読み込まれ実行できたことの証としてclassを付与する。
  // [data-reveal]の非表示デフォルトはこのclassが無い限り安全弁で強制表示される。
  document.documentElement.classList.add('lp5-js-ready');

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSlideshow() {
    var panel = document.getElementById('lp5-image-panel');
    if (!panel) return;

    var slides = panel.querySelectorAll('.lp5-slide');
    if (slides.length < 2) return;

    var toggle = document.getElementById('lp5-slideshow-toggle');
    var intervalSeconds = parseInt(panel.dataset.interval, 10) || 4;
    var current = 0;
    var timer = null;
    var playing = !prefersReducedMotion;
    var panelVisible = window.matchMedia('(min-width: 1024px)');

    function advance() {
      slides[current].classList.remove('is-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
    }

    function start() {
      if (timer || !panelVisible.matches) return;
      timer = setInterval(advance, intervalSeconds * 1000);
    }

    function stop() {
      clearInterval(timer);
      timer = null;
    }

    panelVisible.addEventListener('change', function (event) {
      if (event.matches && playing) {
        start();
      } else {
        stop();
      }
    });

    if (playing) start();

    if (toggle) {
      toggle.hidden = false;

      function syncToggleLabel() {
        var label = playing ? toggle.dataset.labelPause : toggle.dataset.labelPlay;
        toggle.setAttribute('aria-label', label);
        toggle.setAttribute('aria-pressed', String(!playing));
        toggle.classList.toggle('is-paused', !playing);
      }

      syncToggleLabel();

      toggle.addEventListener('click', function () {
        playing = !playing;
        if (playing) {
          start();
        } else {
          stop();
        }
        syncToggleLabel();
      });
    }
  }

  function initReveal() {
    // Hero・最終CTA(lp5-hero-visualスニペット)の出現演出のみ残し、
    // それ以外のセクションのスクロール出現演出は廃止して最初から表示する
    // (IntersectionObserverの監視コスト・レイアウト計算コストの削減)。
    var targets = document.querySelectorAll('[data-reveal]:not(.lp5-hero-visual)');
    targets.forEach(function (el) {
      el.classList.add('is-revealed', 'is-settled');
    });

    var heroTargets = document.querySelectorAll('[data-reveal].lp5-hero-visual');
    if (!heroTargets.length) return;

    if (prefersReducedMotion) {
      heroTargets.forEach(function (el) {
        el.classList.add('is-revealed', 'is-settled');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            el.classList.add('is-revealed');
            // animationがtransformを専有し続けhoverが効かなくなるのを防ぐため、
            // 再生完了後にanimationを外して通常のtransformへ引き渡す
            el.addEventListener(
              'animationend',
              function () {
                el.classList.add('is-settled');
              },
              { once: true }
            );
            obs.unobserve(el);
          }
        });
      },
      { threshold: 0.2 }
    );

    heroTargets.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initFloatingCta() {
    var cta = document.getElementById('lp5-floating-cta');
    if (!cta) return;

    var footer = document.querySelector('.lp5-footer');
    var footerVisible = false;

    function sync() {
      cta.classList.toggle('is-visible', !footerVisible);
    }

    if (footer) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            footerVisible = entry.isIntersecting;
            sync();
          });
        },
        { threshold: 0 }
      ).observe(footer);
    }

    sync();
  }

  function initHeroPattern() {
    var pattern = document.querySelector('.lp5-hero-kv-pattern');
    var container = document.querySelector('.lp5-hero-kv');
    if (!pattern || !container || prefersReducedMotion) return;

    var ticking = false;
    var active = false;

    function update() {
      ticking = false;
      if (!active) return;
      var rect = container.getBoundingClientRect();
      var viewportH = window.innerHeight || document.documentElement.clientHeight;
      var progress = (viewportH - rect.top) / (viewportH + rect.height);
      var offset = (progress - 0.5) * 70;
      pattern.style.transform = 'translate3d(0, ' + offset.toFixed(1) + 'px, 0)';
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          active = entry.isIntersecting;
          if (active) {
            window.addEventListener('scroll', onScroll, { passive: true });
            update();
          } else {
            window.removeEventListener('scroll', onScroll);
          }
        });
      },
      { threshold: 0 }
    ).observe(container);
  }

  function initSectionBackground() {
    var recovery = document.querySelector('.lp5-recovery');
    if (!recovery) return;

    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          document.body.classList.toggle('lp5-bg-recovery', entry.isIntersecting);
        });
      },
      { threshold: 0.3 }
    ).observe(recovery);
  }

  function initRecoveryHeartGraph() {
    var visual = document.querySelector('.lp5-recovery-visual');
    if (!visual) return;

    var svg = visual.querySelector('.lp5-recovery-heart-graph');
    var path = visual.querySelector('.lp5-recovery-heart-graph-path');
    var dot = visual.querySelector('.lp5-recovery-heart-dot');
    if (!svg || !path || !dot) return;

    var hudTime = visual.querySelector('[data-hud-time]');
    var hudBpm = visual.querySelector('[data-hud-bpm]');
    var hudTemp = visual.querySelector('[data-hud-temp]');
    var TEMP_MAX = 40.7;
    var TEMP_MIN = 29.2;
    var lastTempText = null;
    var TIME_START_SEC = 17 * 60 + 21;
    var TIME_END_SEC = 34 * 60 + 18;
    var lastTimeText = null;
    var lastBpmText = null;

    function formatMinSec(totalSeconds) {
      var m = Math.floor(totalSeconds / 60);
      var s = Math.floor(totalSeconds % 60);
      return (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
    }

    // 1文字ずつ固定幅のboxに入れて、桁が変わっても横幅がガタつかないようにする
    function setDigits(el, text) {
      el.innerHTML = '';
      for (var i = 0; i < text.length; i++) {
        var span = document.createElement('span');
        span.className = 'lp5-recovery-hud-digit';
        if (text[i] === ':') {
          span.className += ' lp5-recovery-hud-digit--colon';
        } else if (text[i] === '.') {
          span.className += ' lp5-recovery-hud-digit--dot';
        }
        span.textContent = text[i];
        el.appendChild(span);
      }
    }

    // 楕円の横流れ(lp5-marquee)と完全同期させるための共通周期(assets/lp5-split-layout.cssと同じ値)
    var DURATION = 26000;
    var pathLength = path.getTotalLength();
    var viewBox = svg.viewBox.baseVal;

    function setDotAtProgress(progress) {
      var point = path.getPointAtLength(pathLength * progress);
      var svgRect = svg.getBoundingClientRect();
      var containerRect = visual.getBoundingClientRect();
      if (!svgRect.width || !svgRect.height) return;

      // preserveAspectRatio="xMidYMid meet"(表示用<img>のobject-fit:containと同じ挙動)に合わせて
      // 均一スケール+中央寄せのレターボックス分を考慮する
      var scale = Math.min(svgRect.width / viewBox.width, svgRect.height / viewBox.height);
      var contentWidth = viewBox.width * scale;
      var contentHeight = viewBox.height * scale;
      var offsetX = svgRect.left - containerRect.left + (svgRect.width - contentWidth) / 2;
      var offsetY = svgRect.top - containerRect.top + (svgRect.height - contentHeight) / 2;

      dot.style.left = offsetX + point.x * scale + 'px';
      dot.style.top = offsetY + point.y * scale + 'px';

      // 数値HUD: 時間はprogressに合わせて17:21〜34:18を連続的に経過させ、bpmはグラフの高さ(=いまのシーン)に軽く連動させる
      if (hudTime) {
        var currentSec = TIME_START_SEC + (TIME_END_SEC - TIME_START_SEC) * progress;
        var timeText = formatMinSec(currentSec);
        if (timeText !== lastTimeText) {
          lastTimeText = timeText;
          setDigits(hudTime, timeText);
        }
      }
      var heightRatio = point.y / viewBox.height;
      var bpm = Math.round(140 - heightRatio * 70);
      if (hudBpm) {
        var bpmText = String(bpm);
        if (bpmText !== lastBpmText) {
          lastBpmText = bpmText;
          setDigits(hudBpm, bpmText);
        }
      }
      // 体表温度: bpmほど頻繁には動かさず、bpmが10刻みの帯を跨いだときだけ変化させる
      if (hudTemp) {
        var bpmBand = Math.round(bpm / 10) * 10;
        var bandRatio = (140 - bpmBand) / 70;
        var temp = TEMP_MAX - (TEMP_MAX - TEMP_MIN) * bandRatio;
        var tempText = temp.toFixed(1);
        if (tempText !== lastTempText) {
          lastTempText = tempText;
          setDigits(hudTemp, tempText);
        }
      }
    }

    if (prefersReducedMotion) {
      setDotAtProgress(0.5);
      dot.classList.add('is-active');
      return;
    }

    var rafId = null;

    // performance.now()を直接使い、rAFの一時停止/再開をしてもCSSのlp5-marqueeと位相がずれないようにする
    function frame(timestamp) {
      setDotAtProgress((timestamp % DURATION) / DURATION);
      rafId = requestAnimationFrame(frame);
    }

    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            dot.classList.add('is-active');
            if (rafId === null) {
              rafId = requestAnimationFrame(frame);
            }
          } else if (rafId !== null) {
            cancelAnimationFrame(rafId);
            rafId = null;
          }
        });
      },
      { threshold: 0 }
    ).observe(visual);
  }

  document.addEventListener('DOMContentLoaded', function () {
    [
      initSlideshow,
      initReveal,
      initFloatingCta,
      initHeroPattern,
      initSectionBackground,
      initRecoveryHeartGraph
    ].forEach(function (init) {
      try {
        init();
      } catch (e) {
        console.error('[lp2]', init.name, 'failed:', e);
      }
    });
  });
})();
